export default (state): any => {
  const {
    navigator: { userAgent },
    screen: { height, width, colorDepth }
  } = window

  const {
    publicRuntimeConfig: {
      publicConfig: { locale }
    }
  } = state

  // eslint-disable-next-line no-console
  const javaEnabled = navigator.javaEnabled()

  return {
    acceptHeader: 'any',
    colorDepth,
    javaEnabled,
    javaScriptEnabled: true,
    language: locale,
    screenHeight: height,
    screenWidth: width,
    timeZoneOffset: new Date().getTimezoneOffset(),
    userAgent
  }
}
